import React from "react"
import { connect } from "react-redux"
import { hidePopup } from "../store/action"
import PropTypes from "prop-types"
import Dialog from "@material-ui/core/Dialog"
import Slide from "@material-ui/core/Slide"
import { withStyles } from "@material-ui/core/styles"

function Transition(props) {
  return <Slide direction='up' {...props} />
}

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
  paper: {
    background: "transparent",
    boxShadow: "none",
    margin: 0,
    marginLeft: "-5px",
  },
  backdrop: {
    background: "#000",
    opacity: "0.84!important",
  },
})

const Popup = ({
  renderComponent,
  showPopup,
  style,
  hidePopup,
  fullScreen,
  classes,
  type,
}) => {
  if (!renderComponent || !showPopup) {
    return null
  }
  return (
    <Dialog
      fullScreen={fullScreen}
      open={showPopup}
      onClose={hidePopup}
      TransitionComponent={Transition}
      style={{ background: "transparent" }}
      classes={{ paper: classes.paper }}
      BackdropProps={{
        classes: {
          root: classes.backdrop,
        },
      }}
      disableBackdropClick={type === "campaign" ? true : false}
      disableEscapeKeyDown={type === "campaign" ? true : false}
    >
      {renderComponent()}
    </Dialog>
  )
}

Popup.defaultProps = {
  style: {},
  fullScreen: false,
}

Popup.propTypes = {
  showPopup: PropTypes.bool,
  style: PropTypes.object,
  renderComponent: PropTypes.func,
}

export default withStyles(styles)(
  connect(
    (state, ownProps) => {
      let mapStateToProps = {}
      const popupState = state.component.popupState
      if (popupState) {
        mapStateToProps.renderComponent = popupState.renderComponent
        mapStateToProps.showPopup = popupState.showPopup
        mapStateToProps.fullScreen = popupState.fullScreen
        mapStateToProps.style = popupState.style
      }

      return mapStateToProps
    },
    { hidePopup }
  )(Popup)
)



// WEBPACK FOOTER //
// ./src/components/Popup.js